import type { ApiClient } from './client.js';

/**
 * 付款入口(下单 / 订单列表带回;课程包 / 报名费 / 模块采购 / 算力包同一形状):
 * provider = mock(开发演示:模拟按钮)· wechat(微信扫码:付款面板再取二维码)· none(没接通道);
 * stale = 下单时的通道已经换了,要取消后重新下单。
 */
export interface PayInfo {
  intentId: string;
  provider: string;
  amountCents?: number;
  expiresAt?: string | null;
  mockConfirmPath?: string;
  qr?: string;
  stale?: boolean;
}
export interface PayState {
  status: string;
  paid: boolean;
  closed: boolean;
}
export interface PayMethods {
  provider: string;
  methods: ('wechat' | 'alipay')[];
}

export const PAY_METHOD_LABELS: Record<string, string> = { wechat: '微信支付', alipay: '支付宝' };

export function payApi(api: ApiClient) {
  const p = (intentId: string) => `/v1/pay/${encodeURIComponent(intentId)}`;
  let methods: Promise<PayMethods> | null = null;
  return {
    /** 现在能在线付的方式(整个会话缓存一次) */
    methods: () =>
      (methods ??= api
        .get<PayMethods>('/v1/pay/methods')
        .catch((e) => ((methods = null), Promise.reject(e)))),
    detail: (intentId: string) =>
      api.get<{ pay: PayInfo | null; order: { id: string; status: string } }>(p(intentId)),
    /** 到账状态;check = 「我已支付」(服务端向通道查一次) */
    status: (intentId: string, check = false) =>
      api.get<PayState>(`${p(intentId)}/status`, check ? { query: { check: '1' } } : undefined),
    mockConfirm: (path: string) => api.post<unknown>(path),
  };
}
export type PayApi = ReturnType<typeof payApi>;
